import { array, date, number, object, string } from 'yup';
import type { AthleteProfileID, PlayerID, TeamID, VideoClipID } from '@common/ids';
import { BatsSportAttributePositions } from '@common/positions';
import { Sport } from '@common/sport';
import { convertSnakeCaseIntoCamelCase, makeEnumSchema, makeUUIDSchema } from './helper';

const PublishStatusSchema = makeEnumSchema(['published', 'unpublished'] as const);
const SportSchema = makeEnumSchema([...Object.values(Sport)]);
const SportAttributePositionsSchema = makeEnumSchema([...Object.values(BatsSportAttributePositions)]);

export const APIAthleteProfileSportAttributesSchema = object({
    positions: array(SportAttributePositionsSchema.required()),
}).transformKeys(convertSnakeCaseIntoCamelCase);

export const APIAthleteProfileSchema = object({
    id: makeUUIDSchema<AthleteProfileID>().required(),
    firstName: string().required(),
    lastName: string().required(),
    avatarUrl: string().nullable(),
    bio: string().nullable(),
    graduationYear: string().nullable(),
    sportAttributes: APIAthleteProfileSportAttributesSchema.nullable(),
    publishStatus: PublishStatusSchema.required(),
    capabilityToken: string().required(),
    sport: SportSchema.nullable(),
}).transformKeys(convertSnakeCaseIntoCamelCase);

export const APIAthleteProfileClipsSchema = object({
    id: makeUUIDSchema<VideoClipID>().required(),
    adminTeamName: string().nullable(),
    opponentTeamName: string().nullable(),
    timestamp: date().required(),
    duration: number().required(),
    thumbnailUrl: string().required(),
    playType: string().nullable(),
    playerRole: string().nullable(),
    title: string().nullable(),
}).transformKeys(convertSnakeCaseIntoCamelCase);

export const APIAthleteProfileClipsListSchema = array(APIAthleteProfileClipsSchema).required();

export const APIAthleteProfilePlayerStatsDataSchema = object({
    defense: object({}),
    general: object({}),
    offense: object({}),
}).transformKeys(convertSnakeCaseIntoCamelCase);

export const APIAthleteProfileCareerStatsSchema = object({
    athleteProfileId: makeUUIDSchema<AthleteProfileID>().nullable(),
    playerStatsData: array(
        object({
            playerId: makeUUIDSchema<PlayerID>().nullable(),
            teamId: makeUUIDSchema<TeamID>().nullable(),
            info: object({
                seasonDisplayName: string().nullable(),
                teamDisplayName: string().nullable(),
            }).transformKeys(convertSnakeCaseIntoCamelCase),
            stats: APIAthleteProfilePlayerStatsDataSchema.nullable(),
        }).transformKeys(convertSnakeCaseIntoCamelCase),
    ).nullable(),
    aggregatedStatsData: APIAthleteProfilePlayerStatsDataSchema.nullable(),
})
    .nullable()
    .transformKeys(convertSnakeCaseIntoCamelCase);
